import { OutcomeEvent } from "../scripts/outcomes.entities";
import { OutcomesLookup } from "../scripts/outcomes.lookup";



export class OutcomesSummarySeries {
    name: string;
    type: string;
    typeId: number; //visitId, siteNumber, etc.
    sortValue: number;
    outcomes: Map<number, OutcomeEvent[]>;

    constructor(name: string, type: string, typeId: number) {
        this.name = name;
        this.type = type;
        this.typeId = typeId;
        this.sortValue = (type == "outcome") ? OutcomesLookup.GetOutcomeOrdering(typeId) : 0;
        this.outcomes = new Map<number, OutcomeEvent[]>();
    }

    addOutcomeEvent(event: OutcomeEvent): void {

        //Visit status
        let outcomeArray: OutcomeEvent[];
        if (this.outcomes.has(event.OutcomeStatusId)) { outcomeArray = this.outcomes.get(event.OutcomeStatusId); }
        else { outcomeArray = []; }
        outcomeArray.push(event);
        this.outcomes.set(event.OutcomeStatusId, outcomeArray);


        if (this.type == "site") {
            this.sortValue += 1;
        }

        if (event.OutcomeStatusId == 4) { //not available
            if (this.outcomes.has(event.ReasonId)) { outcomeArray = this.outcomes.get(event.ReasonId); }
            else { outcomeArray = []; }
            outcomeArray.push(event);
            this.outcomes.set(event.ReasonId, outcomeArray);
        }
    }
}